import React from "react";
import useLanguage from "./useLanguage";
import Language from "./Components/Language";

const LanguageIndex: React.FC = () => {

  return <Language />;
};
export default LanguageIndex;
